import ApiURL from "../../services/ApiURL"

export const SECTION_TYPES = {
  SCHEDULE_CLASS: "schedule_class",
  BOOKED_CLASS: "booked_class",
  CATEGORY: "category",
  FEATURED_CLASS: "featured_class",
  ONDEMAND_CLASS: "ondemand_class",
  TRENDING_CLASS: "trending_class",
  PAST_HISTORY_CLASS: "past_history_class",
}

export function getURLFromSectionName(sectionName) {
  switch (sectionName) {
    case "live_and_upcoming":
      return "_listLiveAndUpcomingActivities"
    case "my_upcoming_classes":
      return "_listBookedActivities"
    case "recommendation":
      return "_recommendedOndemandActivities"
    case "new_classes":
      return "_newOndemandActivities"
    case "trending_class":
      return "_newOndemandActivities"
    default:
      return null
  }
}
